<template>
  <div>
    <Modal v-model="isShow" :mask-closable="false" @on-ok="ok"
           :loading="loading"
           @on-cancel="cancel"
           :class-name="z100000"
           :width="660"
    >
      <h3 slot="header" class="modal-header">角色列表</h3>
      <div class="label-center" v-if="this.appType === 0">
        <span class="label">所属应用：</span>
        <Select v-model="appType" @on-change="changeAppType" class="item-width">
          <Option v-for="item in appTypeList" :value="item.value" :key="'keyB'+item.value">{{item.text}}</Option>
        </Select>
      </div>
      <Table  ref="selection" :columns="columns" :data="data" @on-selection-change="selectItem" height="500"></Table>
    </Modal>
  </div>


</template>
<script>
  import {rolelist} from "../../../../api/character";
  import {setTableChecked} from "../../js/systemmanage";

  export default {
    name: ""   ,
    components:{
    },
    props:{
      n: {
        type: Number,
        default: 0
      },
      roleIdArrStr:{
        type:String,
        default:''
      },
      appType: {
        type: Number,
        default: 0
      },
    },
    watch:{
      n(){
        this.data=[];
        this.rolelist();
        this.selected = []
        this.isShow=true
      }
    },
    data(){
      return {
        data:[],
        columns:[

          {
            type: 'selection',
            width: 60,
            align: 'center'
          },
          {
            title: '机构名称',
            key: 'orgName',
            align:'center'
          },
          {
            title: '所属应用',
            key: 'isZyuName',
            align:'center',
            // render:(h,params)=>{
            //   return h('span',{},params.row['isZyu']==='1'?'盘古系统':'超级ZO')
            // }
          },
          {
            title: '角色名称',
            key: 'roleName',
            align:'center'
          },
        ],
        z100000:'z100000',
        loading: true,
        isShow:false,
        selected:[],
        appTypeList:[{text:'盘古系统',value:1},{text:'超级ZO',value:2},{text:'一三环境',value:3}],
      }
    },
    methods:{
      selectItem(value){
        this.selected=value
      },
      rolelist(){
        let params={
          page:1,
          limit:100,
          appType:this.appType
        };
        rolelist(params).then(res=>{
          if(!res.data){
            return
          }
          this.data=res.data.rows;
          setTableChecked(this.data, this.roleIdArrStr.split(","))
          this.data.forEach(ele => {
            if (ele['_checked']) {
              this.selected.push(ele)
            }
          })
        }).catch(error=>{})
      },
      changeLoading() {
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true
        })
      },
      ok(){
        let dataArr = {
          roleValueArr: [],
          roleNameArr: [],
          appType:1
        };
        if(this.selected.length){
          this.selected.forEach(ele=>{
            dataArr.roleValueArr.push(ele.id);
            dataArr.roleNameArr.push(ele.orgName + '-' + ele.roleName)
          });
        }
        dataArr.appType = this.appType
        this.$emit('getRole', dataArr)

        this.isShow=false
      },
      changeAppType(){
        this.rolelist()
      },
      cancel(){

      }
    }

  }
</script>

<style scoped>

</style>
